export default __webpack_public_path__ + "static/media/advicegradissuegfx-03.1f185bfb.png";